import { render } from "./ThankYouBuying.vue?vue&type=template&id=960bbce2"
import script from "./ThankYouBuying.vue?vue&type=script&lang=js"
export * from "./ThankYouBuying.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__